/**
 * Where a session's list lives: the sessions tab of the record it belongs to.
 *
 * There is no list of every session any more — a session is read among its
 * patient's, couple's or group's. A session with nobody behind it (an
 * anonymous one) falls back to the patients list.
 */
export function subjectSessionsPath(subject: {
    patient_id?: string | null;
    couple_patient_id?: string | null;
    group_patient_id?: string | null;
}): string {
    if (subject.group_patient_id) return `/group-patient/${subject.group_patient_id}?tab=sessions`;
    if (subject.couple_patient_id) return `/couple-patient/${subject.couple_patient_id}?tab=sessions`;
    if (subject.patient_id) return `/patient/${subject.patient_id}?tab=sessions`;
    return "/patients";
}
